'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationNote', ['$scope', '$stateParams', '$state', 'Notes',
        function ($scope, $stateParams, $state, Notes) {
        $scope.resetInvestigation();
        $scope.investigation_note = $stateParams.investigation_note;
        $scope.investigationNoteID = $stateParams.investigationNoteID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        
        if ($stateParams.investigationNoteID != null) {
            Notes.getByID($stateParams.investigationNoteID).then(function (note) {
                $scope.investigation_note = note;
                $scope.loading = false;
            })
        }
        else {
            $scope.investigation_note = {};
            $scope.loading = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            Notes.save($scope.investigation_note, $scope.investigationID).then(function (note) {
                updateArray($scope.investigation.notes, note);
                updateArray($scope.masterInvestigation.notes, note);
                $state.go('internal.licensing.investigation.notes', { id: $scope.investigationID });
                $scope.saving = false;
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            Notes.delete($stateParams.investigationNoteID).then(function () {
                updateArray($scope.investigation.notes, $scope.investigation_note, true);
                updateArray($scope.masterInvestigation.notes, $scope.investigation_note, true);
                $scope.deleting = false;
                $state.go('internal.licensing.investigation.notes', { id: $scope.investigationID });
            })
        }

        $scope.simple = 'simple';
        $scope.cke_skin = 'bootstrapck';
    }])
;